import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  InventoryWarehouseResponseData,
  InventoryWarehousesQueryParams,
  InventoryWarehousesResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const inventoryWarehouseKeys = {
  all: () => ['inventoryWarehouses'] as const,
  list: (props: InventoryWarehousesQueryParams) =>
    [...inventoryWarehouseKeys.all(), 'list', props.url] as const,
  detail: (props: { url: string }) =>
    [...inventoryWarehouseKeys.all(), 'detail', props.url] as const,
};

export const inventoryWarehouseQueries = {
  list: (props: InventoryWarehousesQueryParams) =>
    queryOptions({
      queryKey: inventoryWarehouseKeys.list(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<InventoryWarehousesResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  detail: (props: { url: string }) =>
    queryOptions({
      queryKey: inventoryWarehouseKeys.detail(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<InventoryWarehouseResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    }),
};
